import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import moment from "moment";
import { Box, Tab, Tabs } from "@mui/material";
import MuiPagination from "../FeatureComponents/Pagination";
import DynamicTable from "../FeatureComponents/DynamicTable";
import SearchComponent from "../FeatureComponents/SearchComponent";
import TabsComponent from "../FeatureComponents/TabsComponent";
import axios from "axios";

const FinanceBreachedGrids = () => {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const navigate = useNavigate();
  const loc = useLocation();
  const [loading, setLoading] = useState(false);
  //
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(""); // Debounced value
  const [activeTab, setActiveTab] = useState(loc?.state?.activeTab || 0);
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState([
    { name: "Exceptional approval pending", count: 0 },
    { name: "Exceptional approval done", count: 0 },
    { name: "Approved", count: 0 },
    { name: "Payment Done", count: 0 },
    { name: "Cancelled", count: 0 },
  ]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const headersMap = {
    0: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at", format: "DD/MM/YYYY" },
      { label: "Total Orders", key: "total_orders" },
      {
        label: "L1 Status",
        key: "lvl1_excep_approval_status",
        default: "--NA--",
      },
      {
        label: "L2 Status",
        key: "lvl2_second_excep_approval_status",
        default: "--NA--",
      },
      { label: "Pending Actioner", key: "pending_actioner",default: "--NA--" },
      { label: "Actioner Name", key: "actioner" },
    ],
    1: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at", format: "DD/MM/YYYY" },
      { label: "Total Orders", key: "total_orders" },
      {
        label: "L1 Status",
        key: "lvl1_excep_approval_status",
        default: "--NA--",
      },
      {
        label: "L2 Status",
        key: "lvl2_second_excep_approval_status",
        default: "--NA--",
      },
      { label: "Actioner Name", key: "actioner" },
    ],
    2: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at", format: "DD/MM/YYYY" },
      { label: "Total Orders", key: "total_orders" },
      {
        label: "L1 Status",
        key: "lvl1_excep_approval_status",
        default: "--NA--",
      },
      {
        label: "L2 Status",
        key: "lvl2_second_excep_approval_status",
        default: "--NA--",
      },
      { label: "Actioner Name", key: "actioner" },
    ],
    3: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at", format: "DD/MM/YYYY" },
      { label: "Total Orders", key: "total_orders" },
      {
        label: "L1 Status",
        key: "lvl1_excep_approval_status",
        default: "--NA--",
      },
      {
        label: "L2 Status",
        key: "lvl2_second_excep_approval_status",
        default: "--NA--",
      },
      { label: "Actioner Name", key: "actioner" },
    ],
    4: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at", format: "DD/MM/YYYY" },
      { label: "Total Orders", key: "total_orders" },
      {
        label: "L1 Status",
        key: "lvl1_excep_approval_status",
        default: "--NA--",
      },
      {
        label: "L2 Status",
        key: "lvl2_second_excep_approval_status",
        default: "--NA--",
      },
      { label: "Actioner Name", key: "actioner" },
    ],
  };

  const handleTabChange1 = (event, newValue) => {
    setPage(1);
    setActiveTab(newValue);
  };

  const handleNavigation = (navigate, id) => {
    const indexInPage = tableData.findIndex((row) => row.id === id);
    const gridPage =
      indexInPage >= 0 ? (page - 1) * limit + indexInPage + 1 : 1;

    navigate("/ayekart-fintech/limit-breached-grids/grid-view", {
      state: {
        id,
        activeTab,
        gridPage,
        totalGrids: tabData[activeTab]?.count || 0,
        searchQuery: debouncedSearch || "",
      },
    });
  };

  // Fetch data from API
  const handleSearch = (query) => {
    setPage(1);
    setSearchQuery(query);
  };

  const fetchData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const tabNames = [
      "excep_pending",
      "excep_approved",
      "excep_plus_normal_approved",
      "excep_payment_done",
      "excep_cancelled",
    ];
    const selectedTab = tabNames[activeTab] || "excep_pending";
    try {
      const response = await axios.get(
        `/workflow/api/orders/grids?is_exceptional_grid=true&org_id=3&tab_name=${selectedTab}&page=${page}&limit=${10}${
          debouncedSearch ? "&id=" + debouncedSearch : ""
        }`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.status) {
        setTableData(response.data.grids || []);
      } else {
        setTableData([]);
      }
    } catch (error) {
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataCounts = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `/workflow/api/orders/grids_count_exceptional?org_id=3`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.status) {
        setTabData((prevTabs) =>
          prevTabs.map((tab) => {
            let keyMapping = {
              "Exceptional approval pending": "pending",
              "Exceptional approval done": "approved_exceptional",  
              Approved: "approved_normal",
              "Payment Done": "paid",
              Cancelled: "rejected",
            };

            let key = keyMapping[tab.name] || "";  
            return {
              ...tab,
              count: response.data?.counts[key] || 0,  
            };
          })
        );
      } else {
        console.error("Failed to fetch tab counts.");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataCounts();
  }, []);

  useEffect(() => {
    fetchData();
  }, [activeTab, page, debouncedSearch, navigate]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  return (
    <div
      className="container-fluid mt-3 py-2"
      style={{ backgroundColor: "white" }}
    >
      <Loader loading={loading} />

      <div className="container-fluid mt-2 px-0">
        <div className="text-start" style={{ fontWeight: 500 }}>
          <span className="fs-5 text-primary">
            <span style={{ color: "#172554" }}>
              {userDetails?.user_category !== "Finance" && <span
                type=""
                className="text-primary cursor-pointer"
                onClick={() =>
                  navigate("/ayekart-fintech/orders-with-limit-breached")
                }
              >
                <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i>
                Back /
              </span>}
              <span className="text-primary">Ayekart Fintech</span>
              &nbsp;/ &nbsp;
              <span className="text-danger">Finance Breached Grids</span>
            </span>
          </span>
        </div>
      </div>

      {/* New Table */}
      <div className="container-fluid mt-3 px-0">
        <div className="py-2 flex justify-between items-center">
          <TabsComponent
            tabData={tabData}
            activeTab={activeTab}
            onTabChange={handleTabChange1}
          />
        </div>
        <div>
          {/* Search bar */}
          <div className="my-2">
            <SearchComponent onSearch={handleSearch} />
          </div>
        </div>

        <DynamicTable
          headers={headersMap[activeTab]}
          data={tableData}
          action={handleNavigation}
        />

        <div className="flex justify-start pl-2">
          <MuiPagination
            page={page}
            limit={limit}
            totalRecords={tabData[activeTab]?.count || 1}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </div>
      </div>
    </div>
  );
};

export default FinanceBreachedGrids;
